
export class Feriado {

    dataFeriado: Date = new Date();

    descricaoFeriado: string = '';

    constructor() {
    }
}
